export default {
  type: "products",
  name: null,
  sku: null,
  excerpt: "",
  selling_price: null,
  taxes: [],
  picture: null,
  gallery: [],
  relationshipNames: ["organization", "allowedLocations"],
  organization: {
    type: "organizations",
    id: null,
  },
  allowedLocations: [],
};
